'use strict';

import angular from 'angular';
import FormController from 'app/controllers/form';
import raven from 'raven';


class ProcedureTemplateController extends FormController {
    /* @ngInject */
    constructor(
        ProcedureTemplatesService,
        ItemTemplatesService,
        $scope,
        $mdToast,
        $mdDialog,
        $location
    ) {
        let procedureTemplate = $scope.$parent.$resolve.procedureTemplate;
        super(
            procedureTemplate,
            'Modelo de trámite',
            ProcedureTemplatesService,
            null,
            'procedureTemplates'
        );

        Object.assign(this, {
            ProcedureTemplatesService,
            ItemTemplatesService,
            $mdToast,
            $mdDialog,
            $location
        });
        this.btnEnabled = true;
    }

    $onInit() {
        super.$onInit();
        this.itemTemplates = this.model.procedureTemplateItemTemplates
            .map(ptit => ptit.itemTemplate) || [];
        this.children = this.model.children || [];

    }

    updateTotals() {
        let itemsTotalPrice = 0,
            itemsTotalCost = 0;
        this.itemTemplates.forEach(item => {
            itemsTotalPrice += item.price;
            itemsTotalCost += item.cost;
        });

        let childrenTotalPrice = 0,
            childrenTotalCost = 0;
        this.children.forEach(child => {
            childrenTotalPrice += child.totalPrice;
            childrenTotalCost += child.totalCost;
        });

        this.model.totalPrice = itemsTotalPrice + childrenTotalPrice;
        this.model.totalCost = itemsTotalCost + childrenTotalCost;
    }

    queryItemTemplateSearch() {
        let text = this.searchItemTemplateText;
        let orFilter = [
            {
                name: {
                    regexp: `^.*${text}.*$/i`
                }
            }
        ];
        let id = parseInt(text, 10);
        if (!isNaN(id)) {
            orFilter.push({
                id: id
            });
        }
        return this.ItemTemplatesService.find({
            filter: {
                where: {
                    or: orFilter
                }
            }
        });
    }

    queryProcedureTemplateSearch() {
        let text = this.searchProcedureTemplateText;
        let nameConstraint = {
            name: {
                regexp: `^.*${text}.*$/i`
            }
        };
        let filter;
        if (this.model.id) {
            filter = {
                where: {
                    and: [
                        nameConstraint,
                        {
                            id: {
                                neq: this.model.id
                            }
                        }
                    ]
                }
            };
        } else {
            filter = {
                where : nameConstraint
            };
        }
        return this.ProcedureTemplatesService.find({
            filter: filter
        });
    }

    addProcedureTemplate(item) {
        return Promise.resolve().then(() => {
            if (!this.model.id) {
                if (this.form.$valid) {
                    this.showSpin = true;
                    return this.model.$save();
                } else {
                    return this.simpleError(
                        'El modelo de tramite necesita un nombre'
                    );
                }
            }
        }).then(() => {
            this.showSpin = false;
            return this.ProcedureTemplatesService.Model.children.link({
                id: this.model.id,
                fk: item.id
            }).$promise;
        }).then(() => {
            this.newProcedureTemplate = null;
            this.children.push(item);
            this.updateTotals();
            this.simpleSuccess();
        }, err => {
            raven.captureException(err);
            this.simpleError();
        });
    }

    removeProcedureTemplate(item) {
        this.ProcedureTemplatesService.Model.children.unlink({
                id: this.model.id,
                fk: item.id
        }).$promise.then(() => {
            let index = this.children.findIndex(pt => pt.id == item.id);
            if (index > -1) {
                this.children.splice(index, 1);
            }
            this.updateTotals();
            this.simpleSuccess();
        }, err => {
            raven.captureException(err);
            this.simpleError();
        });
    }

    addItemTemplate(item) {
        if (!item) {
            return Promise.resolve();
        }
        return Promise.resolve().then(() => {
            if (!this.model.id) {
                if (this.form.$valid) {
                    this.showSpin = true;
                    return this.model.$save();
                } else {
                    return this.simpleError(
                        'El modelo de tramite necesita un nombre'
                    );
                }
            }
        }).then(() => {
            this.showSpin = false;
            this.updateLocation();
            return this.ProcedureTemplatesService.addItemTemplate(
                this.model,
                item
            );
        }).then(() => {
            this.newItemTemplate = null;
            this.itemTemplates.push(item);
            this.updateTotals();
            this.simpleSuccess();
        }, err => {
            console.error(err);
            raven.captureException(err);
            this.simpleError();
        });
    }

    removeItemTemplate(item) {
        this.ProcedureTemplatesService.removeItemTemplate(
                this.model,
                item
        ).then(() => {
            let index = this.itemTemplates.findIndex(it => it.id == item.id);
            if (index > -1) {
                this.itemTemplates.splice(index, 1);
            }
            this.updateTotals();
            this.simpleSuccess();
        }, err => {
            raven.captureException(err);
            this.simpleError();
        });
    }
}

export default ProcedureTemplateController;
